import { Typography, Paper } from "@mui/material";

const WelcomeBox = () => {
    return (
        <Paper
            elevation={2}
            sx={{
                padding: 3,
                borderRadius: 3,
                marginTop: 3,
                backgroundColor: (theme) => theme.palette.missionGold.cream,
            }}
        >
            <Typography
                variant="h4"
                component="h2"
                sx={{ fontWeight: 600, marginBottom: 1 }}
            >
                Welcome
            </Typography>

            <Typography variant="body1" sx={{ fontSize: "1.05rem" }}>
                We are City St George’s Aero Society — a student-led group passionate
                about aerospace engineering, rocketry, and space-related missions.
                Explore our projects, missions, upcoming events, and join us in building
                the next generation of aerospace innovation.
            </Typography>
        </Paper>
    );
};

export default WelcomeBox;